export const AGENT_LISTS = [
  'xiaopai',
  'nemo@pplabs.org',
  'p17895959524',
  'fupeilong',
  'zhangjialin',
  'mingfuyun',
  'dayu',
  'youguo',
  'liangjiu',
  'keyun',
  'yizong',
  'wanwu',
  'liqiang123',
  'sushaoye',
  'shanyanyun',
  'ailisi',
  'shenniaokeji',
  'luxi',
  'XGcloud1',
  'XGcloud2',
  'XGcloud3',
  'XGcloud4',
  'XGcloud5',
  'XGcloud6',
  'HScloud1',
  'HScloud2',
  'HScloud3',
  'HScloud4',
  'HScloud5',
  'HScloud6',
  'HScloud7',
  'wuhan',
]

export const incomeWhiteList = [
  '15104', //正式环境账号账号ailisi
  '43' //测试环境账号xiaopai/o7dbar1uw2
]
